import { Box, Typography } from "@mui/material";
import { useSelector } from "src/store";
import { useTheme } from "@mui/material/styles";
import { useEffect } from "react";

export default ({ handleSelectCompetitor, setPlanType }) => {
  const theme = useTheme();
  const state = useSelector((state) => state.bkv);

  return (
    <Box
      sx={{
        border: `2px ${theme.palette.secondary.light} solid`,
        height: { xs: "40vw", sm: "40vw", md: "40vw", lg: "480px" },
        width: { xs: "90%", sm: "90%", md: "90%", lg: "35vw" },
        borderRadius: { xs: "3vw", sm: "3vw", md: "3vw", lg: "20px" },
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        overflowY: "auto",
        overflowAnchor: "none",
      }}
    >
      {state.competitorArray.length ? (
        state.competitorArray?.map((item) => {
          return (
            <Box
              sx={{
                padding: "4% 0% 4% 0%",
                display: "flex",
                paddingLeft: "5%",
                flexDirection: "row",
                // justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                borderRadius:
                  state.gimmicky && item?.Plan_id === state.gimmicky.ProductId
                    ? "8px"
                    : 0,
                boxShadow:
                  state.gimmicky && item?.Plan_id === state.gimmicky.ProductId
                    ? "2px 0px 5px 4px rgba(0, 0, 0, 0.1)"
                    : "none",
                "&:hover": {
                  borderRadius: "8px",
                  backgroundColor: "#0000000a",
                },
              }}
              id={item?.Plan_id}
              onClick={() => {
                handleSelectCompetitor(item);
                setPlanType(item);
              }}
            >
              <Box
                width={{
                  xs: "7.5%",
                  sm: "7.5%",
                  md: "7.5%",
                  lg: "13%",
                }}
                mr={{ md: "3%", lg: "5%" }}
              >
                <img
                  width="100%"
                  src={`https://www.powerlego.com/ApiGateway/v2/logo/provider/${item?.Provider_id}`}
                />
              </Box>
              <Typography
                fontSize={{
                  xs: "2vw",
                  sm: "2vw",
                  md: "2vw",
                  lg: "20px",
                }}
                sx={{ whiteSpace: "wrap" }}
              >
                {item?.Plan_name}
                <br />({item?.Contract_term} Months) [
                {parseInt(item?.Price2000).toFixed(2)}
                c/kWh]
              </Typography>
            </Box>
          );
        })
      ) : (
        <Typography variant="h4" color={"gray"} align="center">
          No plans found
        </Typography>
      )}
    </Box>
  );
};
